import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { MedicalInformationModal, MedicalInformationPreview } from './MedicalInformationModal';

type MedicalInformationModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => ReactElement;

type MedicalInformationModalOpenerProps = {
   readonly medicalInformation: MedicalInformationPreview;
   readonly children: MedicalInformationModalOpenerRenderer;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
};

export const MedicalInformationModalOpener = (props: MedicalInformationModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <MedicalInformationModal
               medicalInformation={props.medicalInformation}
               onClose={closeModal}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         ) : null}
      </>
   );
};
